import { ref, customRef } from 'vue'

export function useDebouncedRef<T>(value: T, delay = 300) {
  return customRef((track, trigger) => {
    let timeout: ReturnType<typeof setTimeout>
    return {
      get() {
        track()
        return value
      },
      set(newValue: T) {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          value = newValue
          trigger()
        }, delay)
      }
    }
  })
}

export function useDebounce<T extends (...args: any[]) => any>(
  fn: T,
  delay = 300
) {
  const timeoutRef = ref<ReturnType<typeof setTimeout>>()

  const debouncedFn = (...args: Parameters<T>) => {
    clearTimeout(timeoutRef.value)
    timeoutRef.value = setTimeout(() => {
      fn(...args)
    }, delay)
  }

  return debouncedFn
} 